module.exports = __webpack_public_path__ + "img/contactus_left_bar.a96680ef.jpg";